import { createSelector } from 'reselect'
import { uniqBy } from 'lodash'

const stateActivities = state => state

const mapForDropdown = activities => {
  return uniqBy(activities, 'parent.id')
    .filter(item => item.parent)
    .map(item => item.parent)
}

export default createSelector(stateActivities, mapForDropdown)
